import styled from 'styled-components';

export default styled.div`
  font-size: 16px;
  color: ${p => p.theme.colors.neutral7};
`;
